export enum PersonaType {
  Vendor = 1,
  Partner = 2,
  SMB = 3,
}

export enum MarketingType {
  Partner = 1,
  EndUser = 2,
}

export enum SelectedTab {
  ProductInformation = 0,
  ScreenshotsAndFiles = 1,
  EditionsAndPricing = 2,
}
